
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CompanyHeader from "@/components/base/table/header/CompanyHeader.vue";
import Banner from "@components/semantics/BannerCompany.vue";
import { Action, Getter } from "vuex-class";
import config from "@/config";
import Pagination from "@components/base/pagination/PcmPagination.vue";
import { getReportAll } from "@/api/policy";

@Component({
  name: "Company",
  components: { Banner, Pagination, CompanyHeader },
})
export default class Company extends Vue {
  @Action("searchCompanyData") private searchCompanyData: any;
  @Getter("id") private id!: any;
  @Getter("cityId") private cityId!: any;
  @Getter("role") private role: any;
  // @Action("policy/getMatchList") private getMatchList: any;
  @Action("policy/searchPolicyData2") private searchPolicyData2: any;
  @Action("policy/getPolicyNewCount") private getPolicyNewCount: any;
  companyData = {};
  isDialog = false;
  btnList: any = [
    {
      label: "申报期政策",
      value: "1",
      num: "0",
    },
    {
      label: "非申报期政策",
      value: "2",
      num: "0",
    },
  ];
  active: any = 0;
  activeName: any = "0";
  property1: any = "";
  reg_location: any = "";
  supportAmount: any = "";
  option1 = [
    {
      value: "全部",
      label: "全部",
    },
  ];
  option2 = [
    {
      value: "全部",
      label: "全部",
    },
  ];
  params: any = this.$route.query.params;
  current: any = 1;
  num1 = 0;
  num2 = 0;
  isnum: any = 0;
  isnums: any = 0;
  form = { resource: "" };
  proData = [];
  typeData1 = [
    {
      id: "1",
      label: "国家级",
    },
    {
      id: "2",
      label: "国家级",
    },
    {
      id: "3",
      label: "国家级",
    },
    {
      id: "4",
      label: "国家级",
    },
    {
      id: "5",
      label: "国家级",
    },
    {
      id: "6",
      label: "国家级",
    },
  ];
  activeType1: any = [];
  typeData2: any = [
    {
      id: "1",
      label: "国家级",
    },
    {
      id: "2",
      label: "国家级",
    },
    {
      id: "3",
      label: "国家级",
    },
    {
      id: "4",
      label: "国家级",
    },
    {
      id: "5",
      label: "国家级",
    },
    {
      id: "6",
      label: "国家级",
    },
  ];
  total: any = 0;
  totals: any = 0;
  size: any = 10;
  pages: any = 1;
  activeType2: any = [];
  all: any = "";
  created() {
    this.getCompanyData();
    this.getMatchList();
  }
  currentChange(params: any) {
    this.current = params;
    this.getMatchList();
  }
  indexMethod(index: number) {
    return index + (this.current - 1) * 10 + 1;
  }
  goReport(id: any) {
    this.$router.push({
      name: "pcmMatchResult",
      query: {
        id,
        areaCode: this.cityId,
        params: this.$route.query.params,
      },
    });
  }
  // 第二层tab切换
  handleClick(index: any) {
    this.activeName = index.index;
    this.getMatchList();
  }
  // 第一层tab切换
  handleClickBtn(index: any) {
    this.active = index;
    this.current = 1;
    this.getMatchList();
  }
  getCaption(obj: any, state: any) {
    var index = obj.lastIndexOf(",");
    if (state == 0) {
      obj = obj.substring(0, index);
    } else {
      obj = obj.substring(index + 1, obj.length);
    }
    return obj;
  }
  getMatchList() {
    const options = {
      unitName: this.params,
      current: this.current,
      is: this.active == 0 ? 1 : 2,
      size: this.size,
      type: this.activeName,
      // userId: this.id,
      // unitName: this.company,
      // userId: this.id,
      code: this.cityId.substring(0, 6),
    };

    this.getPolicyNewCount(options).then((res: any) => {
      res.data = res.result;
      this.all = res.data.newData.all;
      this.btnList = [
        {
          label: "申报期政策",
          value: "1",
          num: res.data.newData.all,
          btnChild: [
            {
              label: "全部",
              num: res.data.newData.all,
              value: "0",
            },
            {
              label: "中央",
              num: res.data.newData.buwei,
              value: "1",
            },
            {
              label: "省级",
              num: res.data.newData.shengji,
              value: "2",
            },
            {
              label: "市级",
              num: res.data.newData.shiji,
              value: "3",
            },
          ],
        },
        {
          label: "非申报期政策",
          value: "2",
          num: res.data.oldData.all,
          btnChild: [
            {
              label: "全部",
              num: res.data.oldData.all,
              value: "0",
            },
            {
              label: "中央",
              num: res.data.oldData.buwei,
              value: "1",
            },
            {
              label: "省级",
              num: res.data.oldData.shengji,
              value: "2",
            },
            {
              label: "市级",
              num: res.data.oldData.shiji,
              value: "3",
            },
          ],
        },
      ];
    });

    this.searchPolicyData2(options).then((res: any) => {
      let {
        result: { records, total },
        supportAmount,
      } = res;
      if (!records) {
        records = [];
      }
      if (records.length > 0) {
        this.companyData.supportAmount = records[0].totalSupportAmount;
      }
      this.proData = records.map((item: any) => {
        //item.supportAmount = (item.supportAmount / 10000).toFixed(2) + "万元"
        item.supportAmount = item.supportAmount + "万元";
        return item;
      });
      this.total = total;
      this.pages = Math.ceil(total / this.size);

      return records;
    });
  }
  private async getCompanyData() {
    const res = await this.searchCompanyData(this.params).then(
      ({ code, data, msg, result }: any) => {
        data = result;
        if (code === 200) {
          const datasProperty = [];
          const companyData = data;
          this.property1 = companyData.property1;
          this.reg_location = companyData.reg_location;

          this.companyData = {
            unitName: this.params,
            reg_location: this.reg_location,
            property1: this.property1,
          };
          for (const property in companyData) {
            datasProperty.push(property);
          }
          const tagData = datasProperty.filter((property: any) => {
            return property.indexOf("cate_") >= 0;
          });
          const tags: any = [];
          tagData.map((item: any) => {
            tags.push(companyData[item]);
          });

          // 设置标签
          companyData.tags = tags;
          companyData.reg_capital = companyData.reg_capital
            ? Number(companyData.reg_capital).toFixed(2)
            : null;
          return companyData;
        }
      }
    );
    return res;
  }
  private handleChange(value: any) {}
  private tableRowClassName({ row, rowIndex }: any) {
    if (rowIndex % 2 !== 1) {
      return "odd-row";
    }
    return "even-row";
  }
  isKunMing: any = config.isKunMing;
  private handleEdit({ id: policyId }: any, column: any, e: any) {
    this.$router.push({
      path: `/${this.isKunMing ? "kunming" : ""}detail/policy`,
      query: {
        policyId,
        ismatch: "1",
      },
    });
    // this.isDialog = true;
  }
  private handleClose() {
    this.isDialog = false;
  }
  private onclickData1(id: any) {
    if (this.activeType1.includes(id)) {
      const newData: any = [];
      this.activeType1.forEach((item: any) => {
        if (id !== item) {
          newData.push(item);
        }
      });
      this.activeType1 = newData;
    } else {
      this.activeType1.push(id);
    }
  }
  private onclickData2(id: any) {
    if (this.activeType2.includes(id)) {
      const newData: any = [];

      this.activeType2.forEach((item: any) => {
        if (id !== item) {
          newData.push(item);
        }
      });
      this.activeType2 = newData;
    } else {
      this.activeType2.push(id);
    }
  }
  downloadReport() {
    getReportAll({
      unitName: this.params,
      current: this.current,
      is: this.active == 0 ? 1 : 2,
      size: this.size,
      type: this.activeName,
      code: this.cityId.substring(0, 6),
    })
      .then((res) => {
        const { code, result, msg } = res.data;
        let data = result;
        this.$alert("匹配报告密码为登录手机号后四位", "报告下载", {
          confirmButtonText: "去下载",
          callback: (action) => {
            window.open(data);
          },
        });
      })
      .catch((e) => console.error(e));
  }
}
